import React, {Component} from 'react';

class FJQuestionMarkIcon extends Component {
    render() {
        return (
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                 width="22px" height="22px" viewBox="0 0 22 22">
                <path className='c-question-icon_bg' fill="#FF822C" stroke="#FF822C" d="M11,1C5.48,1,1,5.48,1,11c0,5.52,4.48,10,10,10c5.52,0,10-4.48,10-10
	C21,5.48,16.52,1,11,1L11,1z"/>
                <path className='c-question-icon_mark' fill="#FFFFFF" d="M14.07,10.667l-0.9,0.982C12.45,12.427,12,13.066,12,14.666h-2v-0.533
	c0-1.173,0.45-2.239,1.17-3.018l1.24-1.344C12.779,9.387,13,8.854,13,8.267c0-1.173-0.9-2.133-2-2.133c-1.1,0-2,0.96-2,2.133H7
	C7,5.909,8.79,4,11,4s4,1.909,4,4.267C15,9.205,14.641,10.059,14.07,10.667L14.07,10.667z"/>
                <rect className='c-question-icon_mark' x="10" y="16" fill="#FFFFFF" width="2" height="2"/>
            </svg>
        );
    }
}

export default FJQuestionMarkIcon;